import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import AdminPage from "@/pages/AdminPage";
import BlogDetailPage from "@/pages/BlogDetailPage";
import BlogIndexPage from "@/pages/BlogIndexPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import ProzessoptimierungPage from "@/pages/ProzessoptimierungPage";
import DigitalisierungPage from "@/pages/DigitalisierungPage";
import KiBeratungPage from "@/pages/KiBeratungPage";
import SoftwareEntwicklungPage from "@/pages/SoftwareEntwicklungPage";
import WebMarketingPage from "@/pages/WebMarketingPage";
import NewsletterPage from "@/pages/NewsletterPage";
import NewsletterDetailPage from "@/pages/NewsletterDetailPage";
import { UnsubscribePage, ChangeEmailPage, SelfDisclosurePage } from "@/pages/NewsletterSelfServicePages";
import SocialPage from "@/pages/SocialPage";
import PortalPage from "@/pages/PortalPage";
import PortalLandingPage from "@/pages/PortalLandingPage";
import ImpressumPage from "@/pages/ImpressumPage";
import UeberUnsPage from "@/pages/UeberUnsPage";
import ReferenzenPage from "@/pages/ReferenzenPage";
import LeistungenPage from "@/pages/LeistungenPage";
import FallstudienPage from "@/pages/FallstudienPage";
import PortfolioPage from "@/pages/PortfolioPage";
import TerminPage from "@/pages/TerminPage";
import KontaktPage from "@/pages/KontaktPage";
import ROIPage from "@/pages/ROIPage";
import TestimonialSubmitPage from "@/pages/TestimonialSubmitPage";
import NotFoundPage from "@/pages/NotFoundPage";
import { Toaster } from "@/components/ui/sonner";
import CookieBanner from "@/components/CookieBanner";

function App() {
  return (
    <div className="font-ibm">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/blog" element={<BlogIndexPage />} />
          <Route path="/blog/:postId" element={<BlogDetailPage />} />
          <Route path="/prozessoptimierung" element={<ProzessoptimierungPage />} />
          <Route path="/leistungen" element={<LeistungenPage />} />
          <Route path="/digitalisierung" element={<DigitalisierungPage />} />
          <Route path="/ki-beratung" element={<KiBeratungPage />} />
          <Route path="/software-entwicklung" element={<SoftwareEntwicklungPage />} />
          <Route path="/web-marketing" element={<WebMarketingPage />} />
          <Route path="/newsletter" element={<NewsletterPage />} />
          <Route path="/newsletter/:nlId" element={<NewsletterDetailPage />} />
          <Route path="/newsletter/abmelden/:token" element={<UnsubscribePage />} />
          <Route path="/newsletter/email-aendern/:token" element={<ChangeEmailPage />} />
          <Route path="/newsletter/selbstauskunft/:token" element={<SelfDisclosurePage />} />
          <Route path="/social" element={<SocialPage />} />
          <Route path="/portal" element={<PortalLandingPage />} />
          <Route path="/portal/:projectId" element={<PortalPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/ueber-uns" element={<UeberUnsPage />} />
          <Route path="/referenzen" element={<ReferenzenPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/fallstudien" element={<FallstudienPage />} />
          <Route path="/termin" element={<TerminPage />} />
          <Route path="/kontakt" element={<KontaktPage />} />
          <Route path="/roi-rechner" element={<ROIPage />} />
          <Route path="/testimonial/:token" element={<TestimonialSubmitPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      <CookieBanner />
    </div>
  );
}

export default App;
